import { useContext, useEffect } from 'react';
import { AuthContext, checkAuth, initiateXSRFToken } from '../../utilities/auth-context';

const CheckAuth = ({ onAuthenticate }) => {

    const { dispatch } = useContext(AuthContext);

    const permittedRoutes = [
        '/forgot-password',
        '/reset-password',
    ];

    useEffect(() => {
        checkAuth().then(data => {
            if( false === data ){
                
                initiateXSRFToken();
                onAuthenticate( false );

                // Normalize URLs by removing trailing slashes
                const currentUrl = window.location.href.replace(/\/+$/, '');
                const baseUrl = process.env.REACT_APP_BASE_URL.replace(/\/+$/, '');
                if (currentUrl !== baseUrl && ! permittedRoutes.some(route => currentUrl.includes(route))) {
                    window.location.href = process.env.REACT_APP_BASE_URL;
                }
                
            } else {
                dispatch({ type: 'LOGIN', payload: data });
                onAuthenticate( true );
            }
        });
    }, []);

    return null;

};

export default CheckAuth;